"use client";

import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { Button, Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import { ReactNode, useState } from "react";
import { Field } from "../../../components/Field";
import { SERVER_STATE, useForm } from "../../../hooks/useForm";
import { TypeFormField } from "../../content/typegen";

const generalFormFields: [TypeFormField] = [
  {
    type: "text",
    label: "Email-Adresse",
    errorMessage: "Bitte korrekte Email-Adresse eingeben",
    isRequired: true,
    validation: "email",
  },
];

export function PageComponent(): ReactNode {
  const [formAction, setFormAction] = useState("");
  const form = useForm({
    formFieldsPerPerson: [],
    generalFormFields,
    async onSubmit(state, action: "add" | "remove") {
      setFormAction(action);
      const emailField = state.generalFormFields[0];
      if (!emailField) {
        throw new Error("Email field not found");
      }
      const response = await fetch("/api/newsletter", {
        method: action === "add" ? "put" : "delete",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: emailField.value }),
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const data = await response.json();
      if (!data.ok) {
        throw new Error(data.message);
      }
    },
  });
  return (
    <>
      <Heading>Newsletter</Heading>
      <Text mt={4}>
        Ab sofort kann jeder unseren neuen Email-Newsletter abbonieren! Damit
        erfährt man immer als Erster, was im Skiclub Eiselfing so los ist, sei
        es ein neues Event oder eine organisatorische Änderung.
      </Text>
      <Text mt={4}>
        Zum Abbonieren oder Abbestellen des Newsletters einfach in die Box unten
        deine Email-Adresse eintragen:
      </Text>
      {form.state.serverState === SERVER_STATE.SUCCESS ? (
        <Flex p={4} alignItems="center" rounded="md" bg="green.200" mt={4}>
          <CheckIcon />
          <Text ml={4}>
            {formAction === "add"
              ? "Vielen Dank für deine Anmeldung zum Newsletter!"
              : "Wir haben deine Email erfolgreich aus unserem Verteiler entfernt."}
          </Text>
        </Flex>
      ) : null}
      {form.state.serverState === SERVER_STATE.ERROR ? (
        <Flex p={4} alignItems="center" rounded="md" bg="red.200" mt={4}>
          <CloseIcon />
          <Text ml={4}>
            Beim Absenden des Formulars ist ein unbekannter Fehler aufgetreten.
            Wir haben das zur Kenntnis genommen und werden uns schnellstmöglich
            darum kümmern. Bitte versuchen Sie es später noch einmal!
          </Text>
        </Flex>
      ) : null}
      {form.state.serverState === SERVER_STATE.SUBMITTING ? (
        <Flex justifyContent="center" mt={4}>
          <Spinner
            size="xl"
            speed="0.5s"
            thickness="4px"
            color="blue.500"
            emptyColor="gray.200"
          />
        </Flex>
      ) : null}
      {form.state.serverState === SERVER_STATE.NOT_SUBMITTED ? (
        <>
          {form.state.generalFormFields.map((field, index) => (
            <Field
              key={index}
              updateValue={form.updateValue}
              submitCount={form.state.submitCount}
              {...field}
            />
          ))}
          <Button
            colorScheme="blue"
            onClick={() => form.submitForm("add")}
            mt={6}
          >
            anmelden
          </Button>
          <Button onClick={() => form.submitForm("remove")} mt={6} ml={8}>
            abmelden
          </Button>
        </>
      ) : null}
    </>
  );
}
